// CRITICAL: Import React first to ensure it initializes before JSX runtime
// This must be a side-effect import to guarantee React is loaded
import 'react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import { MantineProvider } from '@mantine/core';
import combineProvider from './hooks/combineProvider';
import { ChpProvider } from './hooks/chpContext';
import { HealthPlanProvider } from './hooks/healthPlanContext';
import { DataFormProvider } from './hooks/dataFormContext';
import { PopulationProvider } from './hooks/populationContext';
import { ProviderProvider } from './hooks/providerContext';
import { HedisMetricsProvider } from './hooks/hedisMetricsContext';
import { WidgetProvider } from './hooks/widgetContext';
import { AnalyticProvider } from './hooks/analyticContext';
import { Provider } from 'react-redux';
import store from './store/store';

const AllProvider = combineProvider([
    ChpProvider,
    HealthPlanProvider,
    DataFormProvider,
    PopulationProvider,
    ProviderProvider,
    HedisMetricsProvider,
    WidgetProvider,
    AnalyticProvider,
]);


const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
    <Provider store={store}>
        <MantineProvider>
            <AllProvider>
                <App />
            </AllProvider>
        </MantineProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
